/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CorporateGroupModel } from '../models/corporate-group-model';
import { CorporateGroupWithAdministrativeModel } from '../models/corporate-group-with-administrative-model';
import { deleteApiCorporategroupV1Id } from '../fn/corporate-group/delete-api-corporategroup-v-1-id';
import { DeleteApiCorporategroupV1Id$Params } from '../fn/corporate-group/delete-api-corporategroup-v-1-id';
import { getApiCorporategroupV1$Json } from '../fn/corporate-group/get-api-corporategroup-v-1-json';
import { GetApiCorporategroupV1$Json$Params } from '../fn/corporate-group/get-api-corporategroup-v-1-json';
import { getApiCorporategroupV1$Plain } from '../fn/corporate-group/get-api-corporategroup-v-1-plain';
import { GetApiCorporategroupV1$Plain$Params } from '../fn/corporate-group/get-api-corporategroup-v-1-plain';
import { getApiCorporategroupV1Id$Json } from '../fn/corporate-group/get-api-corporategroup-v-1-id-json';
import { GetApiCorporategroupV1Id$Json$Params } from '../fn/corporate-group/get-api-corporategroup-v-1-id-json';
import { getApiCorporategroupV1Id$Plain } from '../fn/corporate-group/get-api-corporategroup-v-1-id-plain';
import { GetApiCorporategroupV1Id$Plain$Params } from '../fn/corporate-group/get-api-corporategroup-v-1-id-plain';
import { postApiCorporategroupV1$Json } from '../fn/corporate-group/post-api-corporategroup-v-1-json';
import { PostApiCorporategroupV1$Json$Params } from '../fn/corporate-group/post-api-corporategroup-v-1-json';
import { postApiCorporategroupV1$Plain } from '../fn/corporate-group/post-api-corporategroup-v-1-plain';
import { PostApiCorporategroupV1$Plain$Params } from '../fn/corporate-group/post-api-corporategroup-v-1-plain';
import { putApiCorporategroupV1Id$Json } from '../fn/corporate-group/put-api-corporategroup-v-1-id-json';
import { PutApiCorporategroupV1Id$Json$Params } from '../fn/corporate-group/put-api-corporategroup-v-1-id-json';
import { putApiCorporategroupV1Id$Plain } from '../fn/corporate-group/put-api-corporategroup-v-1-id-plain';
import { PutApiCorporategroupV1Id$Plain$Params } from '../fn/corporate-group/put-api-corporategroup-v-1-id-plain';


/**
 * API controller for managing Corporate Groups.
 */
@Injectable({ providedIn: 'root' })
export class CorporateGroupService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getApiCorporategroupV1()` */
  static readonly GetApiCorporategroupV1Path = '/private/v1/corporate-groups';

  /**
   * Retrieves all Corporate Groups.
   *
   * Retrieves all Corporate Groups.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiCorporategroupV1$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCorporategroupV1$Plain$Response(params?: GetApiCorporategroupV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CorporateGroupWithAdministrativeModel>>> {
    return getApiCorporategroupV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all Corporate Groups.
   *
   * Retrieves all Corporate Groups.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiCorporategroupV1$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCorporategroupV1$Plain(params?: GetApiCorporategroupV1$Plain$Params, context?: HttpContext): Observable<Array<CorporateGroupWithAdministrativeModel>> {
    return this.getApiCorporategroupV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CorporateGroupWithAdministrativeModel>>): Array<CorporateGroupWithAdministrativeModel> => r.body)
    );
  }

  /**
   * Retrieves all Corporate Groups.
   *
   * Retrieves all Corporate Groups.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiCorporategroupV1$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCorporategroupV1$Json$Response(params?: GetApiCorporategroupV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CorporateGroupWithAdministrativeModel>>> {
    return getApiCorporategroupV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all Corporate Groups.
   *
   * Retrieves all Corporate Groups.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiCorporategroupV1$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCorporategroupV1$Json(params?: GetApiCorporategroupV1$Json$Params, context?: HttpContext): Observable<Array<CorporateGroupWithAdministrativeModel>> {
    return this.getApiCorporategroupV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CorporateGroupWithAdministrativeModel>>): Array<CorporateGroupWithAdministrativeModel> => r.body)
    );
  }

  /** Path part for operation `postApiCorporategroupV1()` */
  static readonly PostApiCorporategroupV1Path = '/private/v1/corporate-groups';

  /**
   * Creates a new Corporate Group.
   *
   * Creates a new Corporate Group.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCorporategroupV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCorporategroupV1$Plain$Response(params?: PostApiCorporategroupV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CorporateGroupModel>> {
    return postApiCorporategroupV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Corporate Group.
   *
   * Creates a new Corporate Group.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCorporategroupV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCorporategroupV1$Plain(params?: PostApiCorporategroupV1$Plain$Params, context?: HttpContext): Observable<CorporateGroupModel> {
    return this.postApiCorporategroupV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CorporateGroupModel>): CorporateGroupModel => r.body)
    );
  }

  /**
   * Creates a new Corporate Group.
   *
   * Creates a new Corporate Group.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiCorporategroupV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCorporategroupV1$Json$Response(params?: PostApiCorporategroupV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CorporateGroupModel>> {
    return postApiCorporategroupV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Corporate Group.
   *
   * Creates a new Corporate Group.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiCorporategroupV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiCorporategroupV1$Json(params?: PostApiCorporategroupV1$Json$Params, context?: HttpContext): Observable<CorporateGroupModel> {
    return this.postApiCorporategroupV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CorporateGroupModel>): CorporateGroupModel => r.body)
    );
  }

  /** Path part for operation `getApiCorporategroupV1Id()` */
  static readonly GetApiCorporategroupV1IdPath = '/private/v1/corporate-groups/{id}';

  /**
   * Retrieves a Corporate Group by ID.
   *
   * Retrieves a Corporate Group by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiCorporategroupV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCorporategroupV1Id$Plain$Response(params: GetApiCorporategroupV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CorporateGroupModel>> {
    return getApiCorporategroupV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Corporate Group by ID.
   *
   * Retrieves a Corporate Group by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiCorporategroupV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCorporategroupV1Id$Plain(params: GetApiCorporategroupV1Id$Plain$Params, context?: HttpContext): Observable<CorporateGroupModel> {
    return this.getApiCorporategroupV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CorporateGroupModel>): CorporateGroupModel => r.body)
    );
  }

  /**
   * Retrieves a Corporate Group by ID.
   *
   * Retrieves a Corporate Group by ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiCorporategroupV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCorporategroupV1Id$Json$Response(params: GetApiCorporategroupV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CorporateGroupModel>> {
    return getApiCorporategroupV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a Corporate Group by ID.
   *
   * Retrieves a Corporate Group by ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiCorporategroupV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiCorporategroupV1Id$Json(params: GetApiCorporategroupV1Id$Json$Params, context?: HttpContext): Observable<CorporateGroupModel> {
    return this.getApiCorporategroupV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CorporateGroupModel>): CorporateGroupModel => r.body)
    );
  }

  /** Path part for operation `putApiCorporategroupV1Id()` */
  static readonly PutApiCorporategroupV1IdPath = '/private/v1/corporate-groups/{id}';

  /**
   * Updates an existing Corporate Group.
   *
   * Updates an existing Corporate Group.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiCorporategroupV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiCorporategroupV1Id$Plain$Response(params: PutApiCorporategroupV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CorporateGroupModel>> {
    return putApiCorporategroupV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Corporate Group.
   *
   * Updates an existing Corporate Group.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiCorporategroupV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiCorporategroupV1Id$Plain(params: PutApiCorporategroupV1Id$Plain$Params, context?: HttpContext): Observable<CorporateGroupModel> {
    return this.putApiCorporategroupV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CorporateGroupModel>): CorporateGroupModel => r.body)
    );
  }

  /**
   * Updates an existing Corporate Group.
   *
   * Updates an existing Corporate Group.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiCorporategroupV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiCorporategroupV1Id$Json$Response(params: PutApiCorporategroupV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CorporateGroupModel>> {
    return putApiCorporategroupV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Corporate Group.
   *
   * Updates an existing Corporate Group.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiCorporategroupV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiCorporategroupV1Id$Json(params: PutApiCorporategroupV1Id$Json$Params, context?: HttpContext): Observable<CorporateGroupModel> {
    return this.putApiCorporategroupV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CorporateGroupModel>): CorporateGroupModel => r.body)
    );
  }

  /** Path part for operation `deleteApiCorporategroupV1Id()` */
  static readonly DeleteApiCorporategroupV1IdPath = '/private/v1/corporate-groups/{id}';

  /**
   * Deletes a Corporate Group by marking it as logically deleted.
   *
   * Deletes a Corporate Group by marking it as logically deleted.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiCorporategroupV1Id()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiCorporategroupV1Id$Response(params: DeleteApiCorporategroupV1Id$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteApiCorporategroupV1Id(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a Corporate Group by marking it as logically deleted.
   *
   * Deletes a Corporate Group by marking it as logically deleted.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiCorporategroupV1Id$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiCorporategroupV1Id(params: DeleteApiCorporategroupV1Id$Params, context?: HttpContext): Observable<void> {
    return this.deleteApiCorporategroupV1Id$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
